import { render, staticRenderFns } from "./ReminderActivateCards.vue?vue&type=template&id=731680d6"
import script from "./ReminderActivateCards.vue?vue&type=script&lang=js"
export * from "./ReminderActivateCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports